import arff from "refractor/arff";
export default arff;